import * as React from 'react';
const LuFactsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g
      stroke={props.color || '#FFFFFF8C'}
      strokeLinecap="round"
      strokeOpacity={0.55}
      strokeWidth={1.333}
      clipPath="url(#a)"
      opacity={0.7}
    >
      <path d="M9.333 1.333H4a1.333 1.333 0 0 0-1.333 1.334v10.666A1.333 1.333 0 0 0 4 14.667h8a1.333 1.333 0 0 0 1.333-1.334v-8l-4-4Z" />
      <path d="M9.333 1.333v4h4" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default LuFactsIcon;
